$(function () {
  // integrations Integration Features slider
  new Swiper('.integrations__features .swiper-main', {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: true,
    grabCursor: true,
    paginationClickable: true,
    pagination: '.swiper-pagination'
  });

  var $swiperFeaturesMain = document.querySelector('.swiper-main')
  var $swiperPagination = document.querySelector('.swiper-pagination')
  var observer = new MutationObserver(mutationEvent);
  var config = {
    "attributes": true, 
    "subtree": true
  };

  observer.observe($swiperFeaturesMain, config);

  $swiperPagination.addEventListener('click', function(event) {
    if(isSwiperPaginationBullet(event.target)) {
      setHeightSlider()
      scrollToPagination()
    }
  })

  window.addEventListener('resize', function(event) {
    setHeightSlider()
  });

  function mutationEvent() {
    scrollPagination()
    setHeightSlider()
  };

  function scrollPagination() {
    var $activeBullet = document.querySelector('.swiper-pagination-bullet-active')
    var widthActivePaginationBlock = $swiperPagination.offsetWidth
    var scrollLeft = 0

    if(isScrollPagination(widthActivePaginationBlock, $activeBullet)) {
      scrollLeft = $activeBullet.offsetWidth / 2 + $activeBullet.offsetLeft - (widthActivePaginationBlock / 2)
    } 

    $swiperPagination.scrollLeft = scrollLeft
  }

  function isScrollPagination(widthActivePaginationBlock, $activeBullet) {
    return widthActivePaginationBlock / 2 < $activeBullet.offsetWidth / 2 + $activeBullet.offsetLeft
  }

  function setHeightSlider() {
    var $activeSlide = document.querySelector('.swiper-slide-active')
    $swiperFeaturesMain.style.maxHeight = $activeSlide.offsetHeight + 56 + 'px'
  }

  function isSwiperPaginationBullet(elem) {
    var className = 'swiper-pagination-bullet'
    return elem.classList.contains(className)
  }

  function scrollToPagination() {
    var yCoord = $swiperPagination.offsetTop - window.innerHeight + $swiperPagination.offsetHeight
    window.scrollTo(0, yCoord)
  }
})